import { render, staticRenderFns } from "./MultiValueInput.vue?vue&type=template&id=6a2a45fb&scoped=true"
import script from "./MultiValueInput.vue?vue&type=script&lang=js"
export * from "./MultiValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a45fb",
  null
  
)

export default component.exports